var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1192 6.05418V19.7377H5.37059V6.05418H19.1192ZM5.37059 25.1085V19.7377H0V0.683594H24.4898V25.1085H5.37059ZM5.37059 25.1085V30.2329H0V25.1085H5.37059ZM34.1484 7.53125H47.2885V20.6366H37.03V17.7547H44.4069V10.4131H37.03V17.7547H34.1484V7.53125ZM37.03 20.6366V23.3861H34.1484V20.6366H37.03ZM50.1989 11.8698H58.4028V14.6681H52.9975V23.3861H50.1989V11.8698ZM61.3229 11.8698H72.3018V18.7584H66.5459V16.4747H69.5035V14.6681H64.1215V20.5878H72.3018V23.3861H61.3229V11.8698ZM86.3786 8.32142V23.3861H75.3995V11.8698H81.5559V14.1532H78.198V20.5878H83.5801V8.32142H86.3786ZM93.8856 22.8487V19.3213H89.5667V11.8698H92.365V17.0379H98.2045V11.8698H101.003V19.3213H98.2045H96.6841V22.8487H93.8856Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 31,
    viewBox: "0 0 102 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f21fd9383cf01d9d810053aaaf83627a.svg";
export { ForwardRef as ReactComponent };